// A focused number input steps its value when the mouse wheel turns over it, so scrolling a form
// can silently change a price. Blurring during dispatch stops the step and hands the wheel back to
// the page; a passive listener can't preventDefault, and a non-passive one would slow every scroll.
export const installNumberInputWheelGuard = (doc: Document = document): (() => void) => {
  const blurFocusedNumberInput = (event: WheelEvent) => {
    const active = doc.activeElement;
    if (active instanceof HTMLInputElement && active.type === 'number' && active === event.target) {
      active.blur();
    }
  };
  doc.addEventListener('wheel', blurFocusedNumberInput, { capture: true, passive: true });
  return () => doc.removeEventListener('wheel', blurFocusedNumberInput, { capture: true });
};
